import React, { Component } from 'react'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Chip from '@mui/material/Chip'
import Divider from '@mui/material/Divider'
import Alert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import CircularProgress from '@mui/material/CircularProgress'
import Collapse from '@mui/material/Collapse'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import LogoutIcon from '@mui/icons-material/ExitToApp'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import StopCircleIcon from '@mui/icons-material/StopCircle'
import PointOfSaleIcon from '@mui/icons-material/PointOfSale'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'

const BASE = process.env.REACT_APP_URL_BACKEND + '/remote'
const VER = '' + process.env.REACT_APP_VERSION
const LOGO = '/logo_login.png'
const IDLE_MS = 2 * 60 * 1000          // cierre por inactividad: 2 min
const COL = { bar: '#1f2a44', accent: '#2C7FB2' }

function api(path, body, token) {
  return fetch(BASE + path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'x-access-token': token || '', 'dashboard-version': VER },
    body: JSON.stringify(body || {})
  }).then(r => r.json()).then(d => (d && d.status === 1) ? { ok: true, data: d.data, msg: d.message } : { ok: false, msg: (d && d.message) || 'Error' })
    .catch(() => ({ ok: false, msg: 'Error de conexión' }))
}

const COLOR_ESTADO = { inactivo: 'default', habilitado: 'info', contando: 'primary', finalizado: 'success', error: 'error' }
const fmt = (n) => Number(n || 0).toLocaleString('es-CO')

// Convierte el campo "detalle" del deposito ( JSON con currencies[].bills[] ) en una
// lista denominacion -> cantidad, subtotal ( misma logica que el dashboard ). Si no hay
// desglose ( deposito por sobre, o detalle vacio ) devuelve [].
function arqueoDeDetalle(detalle) {
  try {
    const contenido = typeof detalle === 'string' ? JSON.parse(detalle || '{}') : (detalle || {})
    const mapa = new Map()
    Object.values(contenido).forEach((seccion) => {
      if (seccion && seccion.currencies) {
        seccion.currencies.forEach((cur) => {
          (cur.bills || []).forEach((b) => {
            const d = Number(b.denomination)
            const q = Number(b.amount || 0)
            mapa.set(d, (mapa.get(d) || 0) + q)
          })
          ;(cur.coins || []).forEach((c) => {
            const d = Number(c.denomination)
            const q = Number(c.amount || 0)
            mapa.set(d, (mapa.get(d) || 0) + q)
          })
        })
      }
    })
    return Array.from(mapa.entries())
      .filter(([d, q]) => d > 0 && q > 0)
      .sort((a, b) => b[0] - a[0])
      .map(([denominacion, cantidad]) => ({ denominacion, cantidad, subtotal: denominacion * cantidad }))
  } catch (e) { return [] }
}

class RemotePage extends Component {
  constructor(props) {
    super(props)
    let token = null, tipo = null, nombre = null
    try { token = sessionStorage.getItem('remote_token'); tipo = sessionStorage.getItem('remote_tipo'); nombre = sessionStorage.getItem('remote_nombre') } catch (e) { }
    this.state = {
      token, tipo, nombre,
      loginMode: 0, codigoDep: '', codigoTrans: '', claveTrans: '', cargando: false,
      cajeros: [], cajeroSel: '',
      entidades: [], entidadSel: '',
      estado: null, abriendo: false,
      transacciones: [], txExpandida: null,
      snack: { open: false, severity: 'success', msg: '' }
    }
    this.estadoPrev = null   // para detectar la transicion a 'finalizado' y refrescar el historial
    this.lastActivity = Date.now()
    this.actividadHandler = () => { this.lastActivity = Date.now() }
  }

  componentDidMount() { if (this.state.token) { this.cargarCajeros(); this.iniciarWatch() } }
  componentWillUnmount() { if (this.pollTimer) clearInterval(this.pollTimer); this.detenerWatch() }

  // ---- inactividad: cierra sesión tras IDLE_MS sin interacción ----
  iniciarWatch = () => {
    this.lastActivity = Date.now()
    ;['mousedown', 'keydown', 'touchstart', 'scroll'].forEach(ev => window.addEventListener(ev, this.actividadHandler, { passive: true }))
    this.idleTimer = setInterval(() => {
      if (Date.now() - this.lastActivity >= IDLE_MS) this.salir(true)
    }, 10000)
  }
  detenerWatch = () => {
    if (this.idleTimer) { clearInterval(this.idleTimer); this.idleTimer = null }
    ;['mousedown', 'keydown', 'touchstart', 'scroll'].forEach(ev => window.removeEventListener(ev, this.actividadHandler))
  }

  avisar = (severity, msg) => this.setState({ snack: { open: true, severity, msg } })

  sesion = (d) => {
    try { sessionStorage.setItem('remote_token', d.token); sessionStorage.setItem('remote_tipo', d.tipo); sessionStorage.setItem('remote_nombre', d.nombre || '') } catch (e) { }
    this.setState({ token: d.token, tipo: d.tipo, nombre: d.nombre || '' }, () => { this.cargarCajeros(); this.iniciarWatch() })
  }

  salir = (porInactividad) => {
    try { sessionStorage.removeItem('remote_token'); sessionStorage.removeItem('remote_tipo'); sessionStorage.removeItem('remote_nombre') } catch (e) { }
    if (this.pollTimer) clearInterval(this.pollTimer)
    this.detenerWatch()
    this.setState({ token: null, tipo: null, nombre: null, cajeros: [], cajeroSel: '', estado: null })
    if (porInactividad === true) this.avisar('info', 'Sesión cerrada por inactividad')
  }

  loginDepositante = () => {
    if (!this.state.codigoDep.trim()) return this.avisar('warning', 'Ingresa tu código')
    this.setState({ cargando: true })
    api('/login/depositante', { codigo: this.state.codigoDep.trim() }).then(r => {
      this.setState({ cargando: false })
      if (!r.ok) return this.avisar('error', r.msg)
      this.sesion(r.data)
    })
  }

  loginTransportador = () => {
    if (!this.state.codigoTrans.trim() || !this.state.claveTrans) return this.avisar('warning', 'Ingresa código y clave')
    this.setState({ cargando: true })
    api('/login/transportador', { codigo: this.state.codigoTrans.trim(), clave: this.state.claveTrans }).then(r => {
      this.setState({ cargando: false })
      if (!r.ok) return this.avisar('error', r.msg)
      this.sesion(r.data)
    })
  }

  cargarCajeros = () => {
    const path = this.state.tipo === 'transportador' ? '/cajeros-transportador' : '/cajeros'
    api(path, {}, this.state.token).then(r => {
      if (!r.ok) { if (r.msg && r.msg.indexOf('autenticado') !== -1) return this.salir(); return this.avisar('error', r.msg) }
      const cajeros = r.data || []
      this.setState({ cajeros, cajeroSel: cajeros.length === 1 ? cajeros[0].id : '' }, () => {
        if (this.state.tipo === 'depositante' && this.state.cajeroSel) { this.cargarEntidades(); this.iniciarPoll(); this.cargarTransacciones() }
      })
    })
  }

  iniciarPoll = () => {
    if (this.pollTimer) clearInterval(this.pollTimer)
    this.cargarEstado()
    this.pollTimer = setInterval(this.cargarEstado, 3000)
  }

  seleccionarCajero = (e) => {
    this.estadoPrev = null
    this.setState({ cajeroSel: e.target.value, estado: null, entidades: [], entidadSel: '', transacciones: [], txExpandida: null }, () => {
      if (this.pollTimer) clearInterval(this.pollTimer)
      if (this.state.tipo === 'depositante' && this.state.cajeroSel) { this.cargarEntidades(); this.iniciarPoll(); this.cargarTransacciones() }
    })
  }

  // Historial de depositos de este depositante en el cajero ( con detalle de
  // denominaciones ). Se refresca al elegir cajero, al habilitar/finalizar y
  // cuando el deposito pasa a 'finalizado'.
  cargarTransacciones = () => {
    if (!this.state.cajeroSel) return
    api('/transacciones', { id_cajero: this.state.cajeroSel }, this.state.token).then(r => {
      if (r.ok) this.setState({ transacciones: r.data || [] })
    })
  }

  // Entidades que el depositante puede usar en el cajero elegido. Si hay una
  // sola, queda autoseleccionada y el selector no se muestra.
  cargarEntidades = () => {
    if (!this.state.cajeroSel) return
    api('/entidades-cajero', { id_cajero: this.state.cajeroSel }, this.state.token).then(r => {
      if (!r.ok) return
      const ents = r.data || []
      this.setState({ entidades: ents, entidadSel: ents.length === 1 ? ents[0].id : '' })
    })
  }

  cargarEstado = () => {
    if (!this.state.cajeroSel) return
    api('/estado', { id_cajero: this.state.cajeroSel }, this.state.token).then(r => {
      if (!r.ok) return
      // Al pasar a 'finalizado' ( el cajero registro el deposito ) refresca el
      // historial para que la nueva transaccion aparezca abajo.
      if (r.data && r.data.estado === 'finalizado' && this.estadoPrev !== 'finalizado') {
        this.cargarTransacciones()
      }
      this.estadoPrev = r.data ? r.data.estado : null
      this.setState({ estado: r.data })
    })
  }

  habilitar = () => {
    if (this.state.entidades.length > 1 && !this.state.entidadSel) return this.avisar('warning', 'Elige la entidad')
    const body = { id_cajero: this.state.cajeroSel }
    if (this.state.entidadSel) body.id_entidad = this.state.entidadSel
    api('/habilitar', body, this.state.token).then(r => {
      if (!r.ok) return this.avisar('error', r.msg)
      this.avisar('success', 'Depósito habilitado. Inserta los billetes.'); this.cargarEstado(); this.cargarTransacciones()
    })
  }

  finalizar = () => {
    api('/finalizar', { id_cajero: this.state.cajeroSel }, this.state.token).then(r => {
      if (!r.ok) return this.avisar('error', r.msg)
      this.avisar('success', 'Depósito finalizado.'); this.cargarEstado()
      // El deposito tarda unos segundos en registrarse en el servidor; refresca
      // el historial varias veces para que aparezca sin recargar.
      ;[1500, 4000, 8000].forEach(ms => setTimeout(this.cargarTransacciones, ms))
    })
  }

  abrirBoveda = () => {
    if (!this.state.cajeroSel) return this.avisar('warning', 'Selecciona el cajero')
    this.setState({ abriendo: true })
    api('/abrir-boveda', { id_cajero: this.state.cajeroSel }, this.state.token).then(r => {
      this.setState({ abriendo: false })
      this.avisar(r.ok ? 'success' : 'error', r.ok ? 'Orden de apertura enviada al cajero.' : r.msg)
    })
  }

  // ------------------------------- UI -------------------------------
  header() {
    const s = this.state
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.25, bgcolor: COL.bar, color: '#fff', boxShadow: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
          <img src={LOGO} alt="Smart Safe Control" style={{ height: 30 }} onError={(e) => { e.target.style.display = 'none' }} />
          <Typography variant="subtitle1" sx={{ fontWeight: 600, letterSpacing: 0.3 }}>Remoto</Typography>
        </Box>
        {s.token &&
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ textAlign: 'right', lineHeight: 1.1 }}>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>{s.nombre}</Typography>
              <Typography variant="caption" sx={{ opacity: 0.8, textTransform: 'capitalize' }}>{s.tipo}</Typography>
            </Box>
            <IconButton color="inherit" size="small" title="Salir" onClick={() => this.salir()}><LogoutIcon /></IconButton>
          </Box>}
      </Box>
    )
  }

  renderLogin() {
    const s = this.state
    return (
      <Box sx={{ px: 2 }}>
        <Paper elevation={4} sx={{ p: 3, maxWidth: 400, mx: 'auto', mt: { xs: 4, sm: 8 }, borderRadius: 3 }}>
          <Box sx={{ textAlign: 'center', mb: 2 }}>
            <img src={LOGO} alt="Smart Safe Control" style={{ height: 54 }} onError={(e) => { e.target.style.display = 'none' }} />
            <Typography variant="h6" sx={{ mt: 1 }}>Control remoto</Typography>
            <Typography variant="caption" color="text.secondary">Depósito y vaciado a distancia</Typography>
          </Box>
          <Tabs value={s.loginMode} onChange={(e, v) => this.setState({ loginMode: v })} variant="fullWidth" sx={{ mb: 2 }}>
            <Tab icon={<PointOfSaleIcon fontSize="small" />} iconPosition="start" label="Depositante" />
            <Tab icon={<LockOpenIcon fontSize="small" />} iconPosition="start" label="Transportador" />
          </Tabs>
          {s.loginMode === 0 ?
            <Box>
              <TextField fullWidth label="Código" value={s.codigoDep} onChange={e => this.setState({ codigoDep: e.target.value })}
                onKeyDown={e => { if (e.key === 'Enter') this.loginDepositante() }} sx={{ mb: 2 }} autoFocus />
              <Button fullWidth size="large" variant="contained" disabled={s.cargando} onClick={this.loginDepositante} sx={{ py: 1.25 }}>
                {s.cargando ? <CircularProgress size={22} color="inherit" /> : 'Entrar'}
              </Button>
            </Box>
            :
            <Box>
              <TextField fullWidth label="Código" value={s.codigoTrans} onChange={e => this.setState({ codigoTrans: e.target.value })} sx={{ mb: 2 }} />
              <TextField fullWidth type="password" label="Clave" value={s.claveTrans} onChange={e => this.setState({ claveTrans: e.target.value })}
                onKeyDown={e => { if (e.key === 'Enter') this.loginTransportador() }} sx={{ mb: 2 }} />
              <Button fullWidth size="large" variant="contained" disabled={s.cargando} onClick={this.loginTransportador} sx={{ py: 1.25 }}>
                {s.cargando ? <CircularProgress size={22} color="inherit" /> : 'Entrar'}
              </Button>
            </Box>}
          <Typography variant="caption" color="text.secondary" display="block" align="center" sx={{ mt: 2 }}>
            La sesión se cierra tras 2 min de inactividad.
          </Typography>
        </Paper>
      </Box>
    )
  }

  selectorCajero() {
    const s = this.state
    return (
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Cajero</InputLabel>
        <Select label="Cajero" value={s.cajeroSel} onChange={this.seleccionarCajero}>
          {s.cajeros.length === 0 && <MenuItem value="" disabled><em>Sin cajeros sin pantalla</em></MenuItem>}
          {s.cajeros.map(c => <MenuItem key={c.id} value={c.id}>{c.codigo}{c.alias ? ' — ' + c.alias : ''}</MenuItem>)}
        </Select>
      </FormControl>
    )
  }

  renderDepositante() {
    const s = this.state, e = s.estado || {}
    const activo = e.habilitado === 1 || e.estado === 'habilitado' || e.estado === 'contando'
    return (
      <Box sx={{ px: 2 }}>
        <Paper elevation={3} sx={{ p: 3, maxWidth: 480, mx: 'auto', mt: 3, borderRadius: 3 }}>
          {this.selectorCajero()}
          {s.cajeroSel && s.entidades.length > 1 &&
            <FormControl fullWidth sx={{ mb: 2 }} disabled={activo}>
              <InputLabel>Entidad</InputLabel>
              <Select label="Entidad" value={s.entidadSel} onChange={e => this.setState({ entidadSel: e.target.value })}>
                {s.entidades.map(en => <MenuItem key={en.id} value={en.id}>{en.nombre}</MenuItem>)}
              </Select>
            </FormControl>}
          {s.cajeroSel ? <>
            <Box sx={{ textAlign: 'center', py: 2, bgcolor: '#F3F8FB', borderRadius: 2, mb: 2 }}>
              <Typography variant="overline" color="text.secondary">Guardado</Typography>
              {/* Solo muestra el avance del deposito ACTIVO. En reposo va en $0 para
                  no arrastrar el valor del deposito anterior al iniciar sesion. */}
              <Typography variant="h2" sx={{ fontWeight: 700, color: 'success.main', lineHeight: 1.1 }}>${fmt(activo ? e.total_guardado : 0)}</Typography>
              <Box sx={{ mt: 1.5, display: 'flex', gap: 1, justifyContent: 'center', flexWrap: 'wrap' }}>
                <Chip size="small" label={(e.estado || 'inactivo')} color={COLOR_ESTADO[e.estado] || 'default'} sx={{ textTransform: 'capitalize' }} />
                <Chip size="small" label={'Rechazos: ' + (activo ? (e.rechazos || 0) : 0)} color={activo && e.rechazos ? 'warning' : 'default'} />
              </Box>
            </Box>
            {!activo ?
              <Button fullWidth size="large" variant="contained" color="success" startIcon={<PlayArrowIcon />} onClick={this.habilitar} sx={{ py: 1.6, fontSize: 16 }}>
                Habilitar depósito
              </Button>
              :
              <Button fullWidth size="large" variant="contained" color="error" startIcon={<StopCircleIcon />} onClick={this.finalizar} sx={{ py: 1.6, fontSize: 16 }}>
                Finalizar depósito
              </Button>}
            <Divider sx={{ my: 2 }} />
            <Typography variant="caption" color="text.secondary" display="block" align="center">
              {activo ? 'Inserta los billetes. El avance se actualiza solo.' : 'Pulsa habilitar y luego inserta los billetes.'}
            </Typography>
            {this.historialTransacciones()}
          </> :
            <Typography variant="body2" color="text.secondary" align="center" sx={{ py: 2 }}>Selecciona un cajero para comenzar.</Typography>}
        </Paper>
      </Box>
    )
  }

  // Historial de depositos del depositante en el cajero. Cada fila se puede
  // abrir para ver denominaciones y cantidades ( del campo "detalle" ).
  historialTransacciones() {
    const s = this.state
    const txs = s.transacciones || []
    return (
      <Box sx={{ mt: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1 }}>
          <ReceiptLongIcon fontSize="small" sx={{ color: 'text.secondary' }} />
          <Typography variant="subtitle2" color="text.secondary">Mis transacciones</Typography>
        </Box>
        {txs.length === 0 ?
          <Typography variant="caption" color="text.secondary">Aún no hay depósitos registrados en este cajero.</Typography>
          :
          <Box sx={{ border: '1px solid #e3e8ef', borderRadius: 2, overflow: 'hidden' }}>
            {txs.map((t, i) => {
              const abierto = s.txExpandida === t.id
              const arqueo = abierto ? arqueoDeDetalle(t.detalle) : []
              return (
                <Box key={t.id} sx={{ borderTop: i ? '1px solid #eef1f4' : 'none' }}>
                  <Box onClick={() => this.setState({ txExpandida: abierto ? null : t.id })}
                    sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 1.5, py: 1, cursor: 'pointer', '&:hover': { bgcolor: '#f7f9fc' } }}>
                    <Box>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>${fmt(t.valor)} <Typography component="span" variant="caption" color="text.secondary">{t.moneda}</Typography></Typography>
                      <Typography variant="caption" color="text.secondary">{t.fecha}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      {t.finalizacion ? <Chip size="small" variant="outlined" label={t.finalizacion} sx={{ textTransform: 'capitalize' }} /> : null}
                      {abierto ? <ExpandLessIcon color="action" /> : <ExpandMoreIcon color="action" />}
                    </Box>
                  </Box>
                  <Collapse in={abierto} unmountOnExit>
                    <Box sx={{ px: 1.5, pb: 1.5, bgcolor: '#f7f9fc' }}>
                      {arqueo.length === 0 ?
                        <Typography variant="caption" color="text.secondary">Sin desglose de denominaciones.</Typography>
                        :
                        <Table size="small">
                          <TableBody>
                            <TableRow>
                              <TableCell sx={{ fontWeight: 600, borderBottom: '1px solid #e3e8ef', py: 0.5 }}>Denominación</TableCell>
                              <TableCell align="center" sx={{ fontWeight: 600, borderBottom: '1px solid #e3e8ef', py: 0.5 }}>Cantidad</TableCell>
                              <TableCell align="right" sx={{ fontWeight: 600, borderBottom: '1px solid #e3e8ef', py: 0.5 }}>Subtotal</TableCell>
                            </TableRow>
                            {arqueo.map(row => (
                              <TableRow key={row.denominacion}>
                                <TableCell sx={{ py: 0.5 }}>${fmt(row.denominacion)}</TableCell>
                                <TableCell align="center" sx={{ py: 0.5 }}>{row.cantidad}</TableCell>
                                <TableCell align="right" sx={{ py: 0.5 }}>${fmt(row.subtotal)}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>}
                    </Box>
                  </Collapse>
                </Box>
              )
            })}
          </Box>}
      </Box>
    )
  }

  renderTransportador() {
    const s = this.state
    return (
      <Box sx={{ px: 2 }}>
        <Paper elevation={3} sx={{ p: 3, maxWidth: 440, mx: 'auto', mt: 3, borderRadius: 3, textAlign: 'center' }}>
          {this.selectorCajero()}
          <Box sx={{ my: 2 }}>
            <LockOpenIcon sx={{ fontSize: 64, color: s.cajeroSel ? 'error.main' : 'text.disabled' }} />
          </Box>
          <Button variant="contained" color="error" size="large" fullWidth startIcon={<LockOpenIcon />} disabled={s.abriendo || !s.cajeroSel} onClick={this.abrirBoveda} sx={{ py: 1.8, fontSize: 17 }}>
            {s.abriendo ? 'Enviando…' : 'Abrir bóveda para vaciado'}
          </Button>
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 2 }}>
            La apertura queda registrada con tu identidad.
          </Typography>
        </Paper>
      </Box>
    )
  }

  render() {
    const s = this.state
    return (
      <Box sx={{ minHeight: '100vh', bgcolor: '#eef1f4' }}>
        {this.header()}
        {!s.token ? this.renderLogin() : (s.tipo === 'transportador' ? this.renderTransportador() : this.renderDepositante())}
        <Snackbar open={s.snack.open} autoHideDuration={4000} onClose={() => this.setState({ snack: { ...s.snack, open: false } })} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
          <Alert severity={s.snack.severity} onClose={() => this.setState({ snack: { ...s.snack, open: false } })}>{s.snack.msg}</Alert>
        </Snackbar>
      </Box>
    )
  }
}

export default RemotePage
